// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Page-module--pageContainer--3kknJ","picture":"Page-module--picture--3ii6P"};